<template>
  <div>
    <b-col class="total-hours-dashboard">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <h3 class="mb-0 total-hours-time">
            <short-text></short-text><short-text></short-text>
          </h3>
        </div>
      </div>
      <b-row class="total-hour-log">
        <b-col cols="9" class="pl-0 total-hour-log-content">
          <div>
            <div>
              <long-shimmer></long-shimmer>

              <span class="projectname-total-hour">
                <text-shimmer class="mt-1"></text-shimmer>
              </span>
            </div>
          </div>
        </b-col>
        <b-col cols="9" class="pl-0 total-hour-log-content">
          <div>
            <div>
              <long-shimmer></long-shimmer>

              <span class="projectname-total-hour">
                <text-shimmer class="mt-1"></text-shimmer>
              </span>
            </div>
          </div>
        </b-col>
        <b-col cols="9" class="pl-0 total-hour-log-content">
          <div>
            <div>
              <long-shimmer></long-shimmer>

              <span class="projectname-total-hour">
                <text-shimmer class="mt-1"></text-shimmer>
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import ShortText from "./shortText.vue"
import TextShimmer from "./TextShimmer.vue"
import LongShimmer from "./Longshimmer.vue"

export default {
  name: "ActivityShimmer",
  components: {
    ShortText,
    TextShimmer,
    LongShimmer,
  },
}
</script>

<style>
</style>